import { render, staticRenderFns } from "./numAbv.vue?vue&type=template&id=4290787a&"
import script from "./numAbv.vue?vue&type=script&lang=js&"
export * from "./numAbv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports